module.exports = __webpack_public_path__ + "static/carpet-2a4a61bc3b434be3f7ae6deb7ed0a826.jpg";